import { render, staticRenderFns } from "./SuggestionItem.vue?vue&type=template&id=7cb7e688&scoped=true"
import script from "./SuggestionItem.vue?vue&type=script&lang=ts"
export * from "./SuggestionItem.vue?vue&type=script&lang=ts"
import style0 from "./SuggestionItem.vue?vue&type=style&index=0&id=7cb7e688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb7e688",
  null
  
)

export default component.exports